import EnterPop from "@/components/Popups/EnterPop";
import NewFeature from "@/components/Popups/NewFeature";

/**
 * The main idea is to manage the initial popup
 * for the website from one place.
 *
 * @param {boolean} isNewFeature
 * @returns an object with all necessary properties
 * to the popup.
 * @argument key for local storage
 * @argument popup as a vue component
 * @argument args object with other arguments the popup might need.
 */
export function getInitPopup(isNewFeature = false, key = "after-login") {
  if (!isNewFeature) {
    return {
      key,
      popup: EnterPop
      // args: { step: "after-login" }
    };
  }

  return {
    key,
    popup: NewFeature,
    args: {
      title: "רופא/ה יקר/ה",
      content: `ממשק ניהול המרפאה התעדכן.
אנו מזמינים אותך לבצע פעולות עצמאיות במהירות ובקלות, ללא צורך בצוות ביה"ח, בהתאם לבחירתך.`,
      buttonText: "הבנתי"
    }
  };
}

const ENTRANCE_BANNER_KEY = "banner-fixer";
/**
 * Login.vue reloads the window 1s after authentication, so the banner has to
 * wait out that reload - otherwise it is mounted and thrown away unseen.
 */
const ENTRANCE_BANNER_DELAY = 200;

/**
 * Shows the entrance banner once, after authentication.
 * The "already seen" flag is stored only once the user dismisses the banner,
 * so a reload while it is open doesn't consume it.
 *
 * @param {Vue} vm component instance used to open the modal
 */
export function showEntranceBanner(vm) {
  if (localStorage.getItem(ENTRANCE_BANNER_KEY)) return;
  setTimeout(() => {
    if (localStorage.getItem(ENTRANCE_BANNER_KEY)) return;
    vm.$modal.show(
      EnterPop,
      { step: "after-login" },
      { width: "100%", height: "100%", clickToClose: true },
      { closed: () => localStorage.setItem(ENTRANCE_BANNER_KEY, true) }
    );
  }, ENTRANCE_BANNER_DELAY);
}

export function getSurgeryErrorPopup() {
  return {
    popup: NewFeature,
    args: {
      title: "רופא/ה יקר/ה",
      content: `בוצע חיוב ונפתח תיק מטופל. לא ניתן לשבץ מחדש את הניתוח לעזרה יש ליצור קשר עם מוקד חדר ניתוח.`,
      buttonText: "סגור"
    }
  };
}
